import cn from 'clsx';
import { FC } from 'react';

import s from './StickyBottomButtonWrapper.module.scss';

export interface StickyBottomButtonWrapperProps {
  className?: string;
  isInDrawer?: boolean;
}

const StickyBottomButtonWrapper: FC<React.PropsWithChildren<React.PropsWithChildren<StickyBottomButtonWrapperProps>>> = ({
  children,
  className,
  isInDrawer = false
}) => {
  return <div className={cn(s.wrapper, className, !isInDrawer && s.notindrawer)}>{children}</div>;
};

export default StickyBottomButtonWrapper;
